// @flow

import {getRightOffset} from './getRightOffset';
import {getLeftOffset} from './getLeftOffset';
import {getCellStartIndex} from './getCellStartIndex';
import {getCellEndIndex} from './getCellEndIndex';

type Params = {|
    offset: number,
    offsetWidth: Array<number>,
    overscanCellsRatio: number,
    viewportWidth: number,
|};

type GetVisibleCellDataType = {|
    cellStartIndex: number,
    cellEndIndex: number,
    leftOffset: number,
    rightOffset: 'auto' | number,
|};

const DEFAULT_OVERSCAN_RATIO = 1.3;


export const getVisibleCellData = (params: Params): GetVisibleCellDataType => {
    const {offset, offsetWidth, viewportWidth, overscanCellsRatio = DEFAULT_OVERSCAN_RATIO} = params;
    const cellStartIndex = getCellStartIndex({offset, offsetWidth, viewportWidth});
    const cellEndIndex = getCellEndIndex({offset, viewportWidth, overscanCellsRatio, offsetWidth});
    const rightOffset = getRightOffset(offsetWidth, cellEndIndex);
    const leftOffset = getLeftOffset(offsetWidth, cellStartIndex);

    return {
        cellStartIndex,
        cellEndIndex,
        leftOffset,
        rightOffset
    };
};
